import { Routes, Route } from "react-router-dom";
import LandingPage from "./components/Landing/LandingPage";
import Nosotros from "./components/Nosotros/Nosotros";
import Contactanos from "./components/Contact/ContactSection";
import Servicios from "./components/Services/ServicesSection";
import DetalleDra from './components/Nosotros/detalle_dra';
// import Blog from "./components/Blog/Blog";
// import Suscribete from "./components/Suscribete/Suscribete";
// import Tienda from "./components/Tienda/Tienda";
import PlantillaServicios from "./components/Servicios/PlantillaServicio";
import Tratamientos from "./components/tratamientos/tratamientos"; 

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/Nosotros" element={<Nosotros />} />
      <Route path="/Servicios" element={<Servicios />} />
      <Route path="/contactanos" element={<Contactanos />} />
      <Route path="/dra-quintero" element={<DetalleDra />} />
      {/* <Route path="/Blog" element={<Blog />} />
      <Route path="/Suscribete" element={<Suscribete />} />
      <Route path="/Tienda" element={<Tienda />} /> */}
      <Route path="/servicios/:servicioId" element={<PlantillaServicios />} />
      <Route path="/tratamientos/:categoria" element={<Tratamientos />} />
    </Routes>
  );
}

export default AppRoutes;